import { Redirect, Route, Switch } from 'react-router-dom';

import LogIn from 'layout/Guest/components/LogIn/LogIn';
import logoWhite from 'assets/logo-white.svg';
import SignUp from 'layout/Guest/components/SignUp/Success/SignUp';

import LoginQR from './components/LoginQR/LogInQR';

import './Guest.scoped.scss';

const Guest: React.FC = () => {
  return (
    <div className="guest-layout flex">
      <div className="header-responsive">
        <img alt="Logo" className="logo" src={logoWhite} />
      </div>
      <div className="section left-section center flex">
        <div className="overlay" />
        <img alt="Logo" className="logo" src={logoWhite} />
      </div>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/qr" component={LoginQR} />

        <Route path="/redirect/success" component={SignUp} />
        <Route path="*" component={() => <Redirect to="/" />} />
      </Switch>
    </div>
  );
};

export default Guest;
